import { render, staticRenderFns } from "./batch_edit.vue?vue&type=template&id=1c563310&scoped=true&"
import script from "./batch_edit.vue?vue&type=script&lang=js&"
export * from "./batch_edit.vue?vue&type=script&lang=js&"
import style0 from "./batch_edit.vue?vue&type=style&index=0&id=1c563310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c563310",
  null
  
)

export default component.exports